import React, { useEffect, useState, useContext } from "react";
import {
  Card,
  CardBody,
  Input,
  Col,
  Container,
  Row,
  Badge,
  Button,
} from "reactstrap";

import CustomDataTable from "../../Components/CustomTable/CustomTable";
import { Triangle } from "react-loader-spinner";

import CRUDService from "./API_RELATED/CRUDService";

import GeneralCrudModal from "./generalAdmin/GeneralCrudModal";
import UserDetailModal from "./generalAdmin/UserDetailModal";
import toast from "react-hot-toast";

//change the CRUDSERVICE TO ADMIN MADE HERE
//CRUDSERVICE OF GENERALadMIN IS BEIGN USED HERE FOR TEST
//CHNAGE THAT

const Main = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [showSearchedData, setShowSearchedData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [addUser, setAddUser] = useState(false);
  const [editUserData, setEditUserData] = useState({});
  const [userDetailModalState, setUserDetailModalState] = useState({
    isOpen: false,
    data: {},
  });

  useEffect(() => {
    const testCall = async () => {
      try {
        const data = {
          trackEntity: true,
          page: 1,
          pageSize: 10,
        };
        const res = await CRUDService.getList(data);
        console.log(res);
        setData(res.data);
        setShowSearchedData(res.data);
        setLoading(false);
      } catch (err) {
        console.log("error on getting data. ERR: ", err);

        toast.error(
          err.response.data
            ? err.response.data
            : "error occured while fetchiing data"
        );
      }
    };

    if (loading == true) {
      testCall();
    }
  }, [loading]);

  const handleAddUser = () => {
    setEditUserData({});
    // setAddUser(prev=> !prev)
    setIsOpen((prev) => !prev);
  };

  const handleEdit = (row) => {
    setEditUserData(row);
    setIsOpen((prev) => !prev);

    // setAddUser(true)
  };

  const toggleFunc = () => {
    setIsOpen((prev) => !prev);
  };

  const toggleUserDetail = () => {
    setUserDetailModalState((prev) => ({
      ...prev,
      isOpen: !userDetailModalState.isOpen,
    }));
  };

  const handleAPIDelete = async (row) => {
    console.log(row);

    try {
      const res = await CRUDService.delete(row.userId);
      console.log(res);
      setShowSearchedData(res.data);
      setLoading(true);
      toast.success("Deleted Successfully!");
    } catch (err) {
      console.log("error while deleting, err: ", err);

      toast.error(
        err.response.data ? err.response.data : "error occured while deleting"
      );
    }
  };

  const handleUserDetail = async (row) => {
    try {
      const res = await CRUDService.getUserDetail(row.userId);
      console.log(res);
      setUserDetailModalState({
        isOpen: true,
        data: res,
      });
    } catch (err) {
      console.log("error while getting user detail. ERR: ", err);

      toast.error(
        err.response.data
          ? err.response.data
          : "error occured while getting user detail"
      );
    }
  };

  const columns = [
    {
      name: <span className=" fw-bold">SN.</span>,

      sortable: true,
      cell: (row, index) => <div> {index + 1} </div>,
    },

    {
      name: <span className=" fw-bold">Firstname</span>,
      selector: (row) => row.firstName,
      cell: (row) => (
        <div
          style={{
            textDecoration: "underline",
            color: "blue",
            cursor: "pointer",
          }}
          onClick={() => handleUserDetail(row)}
        >
          {" "}
          {row.firstName}{" "}
        </div>
      ),
      sortable: true,
      grow: 2,
    },

    {
      name: <span className=" fw-bold">Lastname</span>,
      selector: (row) => row.lastName,
      sortable: true,
    },

    {
      name: <span className=" fw-bold">Phonenumber</span>,
      selector: (row) => row.phoneNumber,
      sortable: true,
      grow: 2,
    },

    {
      name: <span className=" fw-bold">Address</span>,
      selector: (row) => row.address,
      sortable: true,
      grow: 2,
    },

    {
      name: <span className=" fw-bold">Email</span>,
      selector: (row) => row.email,
      sortable: true,
      grow: 3,
    },

    // {
    //     name: <span className=' fw-bold'>Role</span>,
    //     selector: row => row.role,
    //     cell: (row) => (
    //         <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: '10px', marginBottom: '10px' }}>
    //         {row.role && row.role.map((e, index) => (
    //             <span
    //                 key={index}
    //                 style={{
    //                     backgroundColor: "#ffc107",
    //                     color: "#fff",
    //                     padding: "5px 10px",
    //                     borderRadius: "5px",
    //                     fontSize: "12px",
    //                     fontWeight: "bold",
    //                     display: "inline-block"
    //                 }}
    //             >
    //                 {e}
    //             </span>
    //         ))}
    //     </div>
    //     ),

    // },

    {
      name: <span className="fw-bold">Action</span>,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Button
            color="warning"
            size="sm"
            onClick={() => handleEdit(row)}
            style={{ width: "30px", height: "30px" }}
          >
            {" "}
            <i className="bx bx-edit"></i>
          </Button>
          <Button
            color="danger"
            size="sm"
            onClick={() => handleAPIDelete(row)}
            style={{ width: "30px", height: "30px" }}
          >
            {" "}
            <i className="bx bx-trash"></i>
          </Button>
        </div>
      ),
    },
  ];

  const searchList = (e) => {
    if (e == "") {
      setShowSearchedData(data);
    }
    console.log(data);

    let inputVal = e.toLowerCase();

    const filterItems = (arr, query) => {
      return arr.filter((el) => {
        return el.firstName.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      });
    };

    let filterData = filterItems(data, inputVal);
    setShowSearchedData(filterData);
  };

  document.title = "CRUD ";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* <BreadCrumb title="crud" pageTitle="Superadmin" /> */}

          <Card>
            <CardBody>
              <Row className="g-2">
                <Col sm={4}>
                  {!addUser ? (
                    <div className="search-box">
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="username"
                        onChange={(e) => searchList(e.target.value)}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  ) : (
                    ""
                  )}
                </Col>

                <Col sm={8} className="text-end">
                  <div className="search-box">
                    <Button onClick={handleAddUser}>
                      {addUser ? "Back" : "+ New"}
                    </Button>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CustomDataTable
                    responsive
                    striped
                    pagination
                    fixedHeader
                    persistTableHead
                    progressPending={loading}
                    columns={columns}
                    data={showSearchedData ? showSearchedData : []}
                    customStyles={{
                      headCells: {
                        style: {
                          fontSize: "0.93rem",
                          fontWeight: 610,
                        },
                      },
                      rows: {
                        style: {
                          fontSize: "0.9rem",
                        },
                      },
                    }}
                    progressComponent={
                      <div className="my-3">
                        <Triangle
                          visible={true}
                          height="80"
                          width="80"
                          color="#5B71B9"
                          ariaLabel="triangle-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                        />
                        <h5 className="mt-1">Loading...</h5>
                      </div>
                    }
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <GeneralCrudModal
          isOpen={isOpen}
          toggle={toggleFunc}
          editUserData={editUserData}
          setLoading={setLoading}
        />

        <UserDetailModal
          isOpen={userDetailModalState.isOpen}
          toggle={toggleUserDetail}
          data={userDetailModalState.data}
        />
      </div>
    </React.Fragment>
  );
};

export default Main;
